import GlazingSelectorTemplate from './glazingSelector.html';

const glazingSelector = () => ({
    template: GlazingSelectorTemplate,
    scope: {
        selectedSpacerId: '=',
        selectedGlazingId: '=',
        editSource: '<',
        changeStep: '&?',
        closeBoxCallback: '&?',
    },
    controller: 'GlazingSelectorCtrl',
    controllerAs: 'glazingSelector',
    bindToController: true
});

export default glazingSelector;
